import httpRequest from "@/services/httpRequest"
import i18n from '@/locales/index'

const t = i18n.global.t

export default ({
  namespaced: true,
  state: {
    studyrooms: null,
    studyroom: null,
    postPage: 1,
    postPageSize: 10,
    studyroomPosts: null,
    nowTime: null,
  },
  actions: {
    async getStudyRooms({rootState, state}, params=null) {
      const url = `${rootState.baseURL}/api/v1/studyroom`
      if (params == null) {
        params = {
          archived: 'False',
          ordering: '-created',
        }
      }

      const payload = {
        options: {
          url: url,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status == 200) {
        state.studyrooms = resp.data.results;
      } else {
        //console.log('ERROR', resp)
      }
    },
    async getStudyRoom({rootState, state}, id) {
      const url = `${rootState.baseURL}/api/v1/studyroom/${id}`
      const payload = {
        options: {
          url: url,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status == 200) {
        state.studyroom = resp.data;
      } else {
        //console.log('ERROR', resp)
      }
    },
    async createStudyRoom({rootState}, {data, notifData}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyroom`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)

      if (notifData) {
        rootState.showPopUpModal = true;
        if (res.status === 201) {
          notifData.value.isSuccess = true
          notifData.value.title = t('Berhasil Ditambahkan')
          notifData.value.description = t('Ruang belajar baru telah berhasil dibuat')
        } else if (res.status === 400) {
          notifData.value.isSuccess = false
          notifData.value.title = t('Salah')
          notifData.value.description = t('Kesalahan telah dibuat.') + ' ' + res.data[0]
        }
      }
      rootState.isLoading = false
    },
    async deleteStudyRoom({rootState}, {id, notifData}) {
      //console.log('id', id)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyroom/${id}`,
          method: 'DELETE',
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      if (notifData) {
        rootState.showPopUpModal = true;
        if (res.status === 204) {
          notifData.value.isSuccess = true
          notifData.value.title = t('Berhasil Dihapus')
          notifData.value.description = t('Ruang belajar telah dihapus')
        } else if (res.status === 400) {
          notifData.value.isSuccess = false
          notifData.value.title = t('Salah')
          notifData.value.description = `${t('Kesalahan telah dibuat.')} ` + res.data[0]
        }
      }
      return res
    },
    async editStudyRoom({rootState, state}, {id, data, notifData}) {
      //console.log('id', id)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyroom/${id}`,
          method: 'PATCH',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      if (notifData) {
        //console.log('ADA NOTIFDATA')
        rootState.showPopUpModal = true;
        if (res.status === 200) {
          notifData.value.isSuccess = true
          notifData.value.title = t('Berhasil Diubah')
          notifData.value.description = t('Ruang belajar telah berhasil diubah')
        } else if (res.status === 400) {
          notifData.value.isSuccess = false
          notifData.value.title = t('Salah')
          notifData.value.description = t('Kesalahan telah dibuat.') + ' ' + res.data[0]
        }
      }
      if (res.status === 200 && state.studyrooms != null) {
        let index = null;
        for (let i = 0; i < state.studyrooms.length; i++) {
          const sr = state.studyrooms[i];
          if (sr.id === id) {
            index = i;
            break
          }
        }
        if (index !== null) {
          state.studyrooms[index] = res.data;
        }
      }
      return res
    },
    async getStudyRoomPosts({rootState, state}, {id, params, status='first'}) {
      if (status == 'more') {
        state.postPage += 1
      }
      if (state.postPage < 1) {
        state.postPage = 1
      }
      let url = `${rootState.baseURL}/api/v1/studypost?studyroom=${id}`
      url += `&rows=${state.postPageSize}&page=${state.postPage}`
      const payload = {
        options: {
          url: url,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status == 200) {
        // console.log('FIRST KAH', status)
        if (status == 'first') {
          //console.log('langsung replace saja')
          state.studyroomPosts = resp.data.results;
        } else if (resp.data.results.length && Array.isArray(state.studyroomPosts)) {
          resp.data.results.forEach(data => {
            const isThere = state.studyroomPosts.find(post => post.id === data.id)
            if (!isThere) {
              state.studyroomPosts.push(data)
            }
          });
        }
        if (resp.data.results.length != state.postPageSize) {
          state.postPage -= 1
        }
      } else if (resp.status === 404) {
        state.postPage -= 1
      } else {
        state.postPage -= 1
      }
    },
    async getPosts({rootState}, params) {
      let url = `${rootState.baseURL}/api/v1/studypost`
      const payload = {
        options: {
          url: url,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async getFiles({rootState}, params) {
      let url = `${rootState.baseURL}/api/v1/studypostfile`
      const payload = {
        options: {
          url: url,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async getPostComments({rootState, state}, {id, params}) {
      const url = `${rootState.baseURL}/api/v1/studypostcomment?post=${id}&rows=20`
      const payload = {
        options: {
          url: url,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status == 200) {
        return resp.data.results;
      } else {
        return [];
      }
    },
    async postComment({rootState, state}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypostcomment`,
          method: 'POST',
          data: data
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async createPost({rootState}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypost`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      return res
    },
    async reFetchPost({rootState, state}, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypost/${id}`,
          method: 'GET',
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      let index = null
      if (res.status == 200) {
        for (let i = 0; i < state.studyroomPosts.length; i++) {
          const sr = state.studyroomPosts[i];
          if (sr.id === id) {
            index = i;
            break
          }
        }
        if (index !== null) {
          state.studyroomPosts[index] = res.data
        }
      }
      return res
    },
    async createPostFile({rootState}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypostfile`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      return res
    },
    async editPost({rootState, state}, {id, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypost/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      if (res.status === 200) {
        for (let i = 0; i < state.studyroomPosts.length; i++) {
          const sr = state.studyroomPosts[i];
          if (sr.id === id) {
            state.studyroomPosts[i] = res.data
            break
          }
        }
      }
      return res
    },
    async deletePost({rootState, state}, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypost/${id}`,
          method: 'DELETE',
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      let index = null;
      if (res.status === 204) {
        for (let i = 0; i < state.studyroomPosts.length; i++) {
          const sr = state.studyroomPosts[i];
          if (sr.id === id) {
            index = i;
            break
          }
        }
      }
      if (index !== null) {
        state.studyroomPosts.splice(index, 1)
      }
      return res
    },
    async deleteFile({rootState, state}, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studypostfile/${id}`,
          method: 'DELETE',
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      return res
    },
    async getMembers({rootState, state}, studyroomId) {
      const url = `${rootState.baseURL}/api/v1/studyroomstudent?studyroom=${studyroomId}`
      const payload = {
        options: {
          url: url,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status == 200) {
        return resp.data.results;
      } else {
        return [];
      }
    },
    async addClassroom({rootState}, {roomId, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyroom/${roomId}/add_classroom`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      return res
    },
    async removeStudent({rootState}, {roomId, data}) {
      //console.log('remove', roomId, 'data', data)
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyroom/${roomId}/remove_student`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      return res
    },
    async addStudents({rootState}, {roomId, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyroom/${roomId}/add_students`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }

      const res = await httpRequest(payload)
      return res
    },
    async getTasksSubmit({rootState, state}, postId) {
      const url = `${rootState.baseURL}/api/v1/studyposttasksubmit?post=${postId}`
      const payload = {
        options: {
          url: url,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status == 200) {
        return resp.data.results;
      } else {
        return [];
      }
    },
    async getTaskSubmitByPostStudent({rootState}, data) {
      const url = `${rootState.baseURL}/api/v1/studyposttasksubmit/get_by_post_student`
      const payload = {
        options: {
          url: url,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async createSubmitTask({rootState}, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studyposttasksubmit`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async editSubmitTask({rootState}, {id, data}) {
      const url = `${rootState.baseURL}/api/v1/studyposttasksubmit/${id}`
      const payload = {
        options: {
          url: url,
          method: 'PATCH',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async getExaminations({rootState}, params) {
      let url = `${rootState.baseURL}/api/v1/examination`
      const payload = {
        options: {
          url: url,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
  },
  getters: {
    getStudyRoom: (state) => (id) => {
      id = parseInt(id);
      let ret = null;
      for (const sr of state.studyrooms) {
        if (sr.id === id) {
          ret = sr;
          break
        }
      }
      return ret
    }
  }
})